/**
 * Client mirror of server/plansConfig.js — display + client-side UX only.
 * Enforcement is always server-side.
 */

export const PLANS = {
  free: {
    id: 'free',
    name: 'Free',
    priceMonthlyUsd: 0,
    weekly: {
      pod: 2,
      custom: 1
    }
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    priceMonthlyUsd: 24.99,
    weekly: {
      pod: 8,
      custom: 10
    }
  }
}

export function planIdFromSubscription(subscription) {
  const s = String(subscription || 'free').toLowerCase()
  if (s === 'premium' || s === 'pro') return 'pro'
  return 'free'
}

export function isPaidSubscription(subscription) {
  return planIdFromSubscription(subscription) === 'pro'
}

export function getPlan(planIdOrSubscription) {
  const id = PLANS[planIdOrSubscription]
    ? planIdOrSubscription
    : planIdFromSubscription(planIdOrSubscription)
  return PLANS[id] || PLANS.free
}

/**
 * Paid plans offered when a free user runs out, cheapest first.
 * Every feature is free; paid plans only raise the weekly generation allowance.
 * To add a plan: add it to PLANS (and server/plansConfig.js), list it here, and give it a checkout in GenerationPaywallModal.
 */
export const UPGRADE_PLAN_IDS = ['pro']

export function upgradePlans() {
  return UPGRADE_PLAN_IDS.map((id) => PLANS[id]).filter(Boolean)
}

export function isProMember(user, isPremium = false) {
  return Boolean(isPremium || isPaidSubscription(user?.subscription))
}

/** Upgrade offers are hidden for Pro subscribers and admins. */
export function showsUpgradeOffer(user, isPremium = false) {
  if (isProMember(user, isPremium)) return false
  if (user?.isAdmin === true || user?.role === 'admin') return false
  return true
}
